import React from 'react';

interface ParallelogramIconProps extends React.SVGProps<SVGSVGElement> {
  /** Сторона квадрата иконки, как `size` у lucide-react. */
  size?: number;
}

/** Параллелограмм в стиле lucide-react (сетка 24, обводка `currentColor`) — в lucide такой иконки нет. */
function ParallelogramIcon(props: ParallelogramIconProps) {
  const { size = 24, strokeWidth = 2, ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M8 5h14l-6 14H2z" />
    </svg>
  );
}

export default ParallelogramIcon;
